import firebase from "firebase/app";

// Local: run staticDataApi Cloud Function and uncomment:
// const STATIC_DATA_API_BASE = "http://localhost:8080";
const STATIC_DATA_API_BASE =
  process.env.STATIC_DATA_API_BASE || "https://us-central1-hackernoon-app.cloudfunctions.net/staticDataApi";

export async function getStaticDataDoc(docId, select) {
  const url = new URL(`${STATIC_DATA_API_BASE}/${encodeURIComponent(docId)}`);
  if (select?.length) {
    url.searchParams.set("select", select.join(","));
  }
  const response = await fetch(url.toString(), {
    method: "GET",
    headers: {"Content-Type": "application/json"},
  });
  const json = await response.json();
  if (json.status !== "ok" || json.data == null) {
    return null;
  }
  return json.data;
}

export async function putStaticDataDoc(docId, fields) {
  const user = firebase.auth().currentUser;
  if (!user) {
    throw new Error("Not authenticated");
  }
  const token = await user.getIdToken();
  const response = await fetch(`${STATIC_DATA_API_BASE}/${encodeURIComponent(docId)}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(fields),
  });
  const json = await response.json();
  if (!json.ok) {
    throw new Error(json.msg || "Failed to update static data");
  }
  return json;
}
